import React from 'react';
import classNames from 'classnames';

import utilsService from '../../services/UtilsService';

import '../../../css/CustomHtmlOption.scss';

import HtmlComponent from '../HtmlComponent';

const CustomHtmlOption = (props) => {
  const { data, innerProps, innerRef, isFocused } = props;

  innerProps.tabIndex = 0;

  innerProps.onMouseOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  innerProps.onMouseMove = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  let dataLabel = data.viewLabel;
  if (dataLabel?.startsWith?.('<menclose')) {
    dataLabel = `<math>${dataLabel}</math>`;
  }
  const titleText = utilsService.stripTagsAndEntities(dataLabel);
  return (
    <div ref={innerRef} className={classNames({
      'custom-html-dropdown-option': true,
      'is-focused': isFocused,
      'is-selected': props.isSelected
    })} title={titleText} {...innerProps}>
      <HtmlComponent htmlStr={dataLabel} />
    </div>
  );
};

export default CustomHtmlOption;
